/**
 * For account root keys by using the account keyring.
Secret keys of public-key cryptography for example.
 */

import { CryptoContext } from '../../base';
import { AccountRootKeyConfigDumpArgs, AccountRootKeyConfigLoadArgs } from './args';
import { AccountRootKeyConfigV1 } from './v1';
import { AccountRootKeyConfigV2 } from './v2';
import { CU_ANNULLED_BY_PQC_ML, CU_PQC_ML } from '../../feature';

export let ACCOUNT_ROOT_KEY_CRYPTO_CONTEXT = new CryptoContext<
  AccountRootKeyConfigLoadArgs,
  AccountRootKeyConfigDumpArgs
>([
  new AccountRootKeyConfigV1(CU_ANNULLED_BY_PQC_ML), // exclusively for base self-keyring
  new AccountRootKeyConfigV2(CU_PQC_ML), // for non-base self-keyring
]);
